import gsap from 'gsap'
import IMask from 'imask'

const validateField = (field) => {
  const value = field.value + ''
  const required = field.required
  const validator = field.name

  let valid = true

  if (required !== undefined || value.length) {
    switch (validator) {
      case 'phone':
        if (!field.classList.contains('noMask')) {
          valid = value.trim().length === 16
        }
        break
      case 'name':
        valid = !!value.trim().length
        break
      default:
        //valid = !!value.trim().length
        break
    }
  }

  return valid
}

const tlShow = gsap.timeline({ paused: true })

tlShow.add(
  gsap.to('.form__inner', {
    opacity: 0,
    ease: 'expo.out',
    y: -50,
  })
)

if (window.innerWidth <= 768) {
  tlShow.add(
    gsap.fromTo(
      '.form__success-wrapper',
      {
        opacity: 0,
        y: 0,
      },
      {
        opacity: 1,
        zIndex: 1,
        y: -590,
        ease: 'expo.out',
        duration: 0.8,
      }
    ),
    0.8
  )
  tlShow.add(
    gsap.fromTo('.form', { height: 640 }, { height: 550, ease: 'expo.out' }),
    0.3
  )
} else {
  tlShow.add(
    gsap.fromTo(
      '.form__success-wrapper',
      { opacity: 0, y: 0 },
      {
        opacity: 1,
        zIndex: 1,
        y: -760,
        ease: 'expo.out',
        duration: 0.8,
      }
    ),
    0.3
  )
}

const submitForm = async (
  form: HTMLFormElement,
  successBlock: HTMLElement,
  errorEl: HTMLElement
) => {
  if (!form) {
    return
  }

  if (errorEl) {
    errorEl.classList.remove('form__success-wrapper')
  }

  const data = new FormData(form)

  const res = await fetch(`/ajax/form.php`, {
    method: 'POST',
    body: data,
  })

  const json = await res.json()

  if (json && json.success) {
    if (successBlock) {
      tlShow.play()
      form.querySelector('button')?.classList.remove('disable')

      const fields = form.querySelectorAll('.form__input')

      if (fields?.length > 0) {
        fields.forEach((field) => {
          if (field.name === 'name' || field.name === 'phone') {
            field.value = ''
          }
        })
      }
    }
  } else {
    if (errorEl) {
      errorEl.classList.add('form__success-wrapper')
    }
  }
}

export const form = () => {
  const form = document.querySelector('.form')
  const formSuccess = document.querySelector('.form__success-wrapper')
  const successHideBtn = document.querySelector('.form__success-btn')
  const formError = document.querySelector('form__success-wrapper')
  const fields = form?.querySelectorAll('input')
  const phoneField = document.querySelector('.form__input-phone')
  const note = document.querySelector('.form__note')

  const maskOptions = {
    mask: '+{7}(000)000-00-00',
  }

  if (phoneField) {
    IMask(phoneField as HTMLElement, maskOptions)
  }

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault()
      let formValidFields = []

      fields.forEach((field) => {
        let isFieldValid = validateField(field)

        formValidFields.push(isFieldValid)

        if (isFieldValid) {
          field.parentElement.classList.remove('form__label_error')
        } else {
          field.parentElement.classList.add('form__label_error')
        }
      })

      if (formValidFields.filter((el) => el).length === fields?.length) {
        // submit form

        form.querySelector('button')?.classList.add('disable')

        submitForm(
          form as HTMLFormElement,
          formSuccess as HTMLElement,
          formError as HTMLElement
        )

        formValidFields = []
      } else {
        gsap.fromTo(
          note,
          {
            rotateZ: 5,
            scale: 1.05,
            ease: 'elastic.out(1.5, 0.1)',
          },
          {
            rotateZ: 0,
            scale: 1,
            duration: 1,
            ease: 'elastic.out(1.5, 0.1)',
          }
        )

        formValidFields = []
      }
    })

    if (successHideBtn) {
      successHideBtn.addEventListener('click', () => {
        tlShow.reverse()

        const fields = form.querySelectorAll('input')

        if (fields?.length > 0) {
          fields.forEach((field) => {
            if (field.name === 'name' || field.name === 'phone') {
              field.value = ''
            }
          })
        }
      })
    }
  }
}

export const openPopup = () => {
  const openBtns = document.querySelector('[href="#popup_form"]')
  const popup = document.querySelector('.popup__outher')
  const closeBtn = document.querySelector('.popup__close')

  if (popup && openBtns) {
    openBtns?.addEventListener('click', function (e) {
      e.preventDefault()
      popup.classList.add('active')
      setTimeout(function () {
        popup.classList.add('animated')
      }, 10)
    })
  }

  if (popup && closeBtn) {
    closeBtn?.addEventListener('click', function (e) {
      popup.classList.remove('animated')
      setTimeout(function () {
        popup.classList.remove('active')
        tlShow.reverse()
      }, 400)
    })
  }
}
